import React, { useState, useEffect } from "react";
import "./style.scss";
import Button from "../../components/Button";
import Localized from "../../Localized";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import { openTelegramLink, retrieveLaunchParams, popup, openLink } from "@telegram-apps/sdk";
import { navigateToPage, setProjectId } from "../../redux/slices/windowSlice";

import officeBagDark from "../../img/icons/dark/office-bag.svg";
import addDark from "../../img/icons/dark/add.svg";
import creditCardDark from "../../img/icons/dark/credit-card.svg";
import supportIconDark from "../../img/icons/dark/support.svg";
import membersIcon from "../../img/icons/members.svg";
import reportsIcon from "../../img/icons/reports.svg";
import dashboardIcon from "../../img/icons/dashboard.svg";
import graphIcon from "../../img/icons/graph.svg";
import statisticIcon from "../../img/icons/statistic.svg";
import paymentsIcon from "../../img/icons/payments.svg";
import ListButtons from "../../components/ListButtons";
import { useLoadSavedCards } from "../../hooks/useLoadSavedCards";
import SelectPicker from "../../components/SelectPicker";
import { useLoadStatistic } from "../../hooks/useLoadStatistic";
import { useLoadGroupsAndPlans } from "../../hooks/useLoadGroupsAndPlans";
import { useLoadProjectTariff } from "../../hooks/useLoadProjectTariff";
import { useNavigate } from "react-router-dom";

const MainScreen = () => {
    const dispatch = useAppDispatch();
    let navigate = useNavigate();
    const { initDataRaw, initData } = retrieveLaunchParams();

    const { projectId, myProjects, token } = useAppSelector(
        (state: RootState) => state.windowSlice
    );

    const [redirectPage, setRedirectPage] = useState("");
    const { loadSavedCards, isLoading: isLoadingSavedCards, data: savedCards, isError: isErrorSavedCards } = useLoadSavedCards(projectId);
    const { loadStatistic, isLoading: isLoadingStatistic, data: statistic, isError: isErrorStatistic } = useLoadStatistic(projectId);
    const { loadGroupsAndPlans, isLoading: isLoadingGroupsAndPlans, data: groupsAndPlans, isError: isErrorGroupsAndPlans } = useLoadGroupsAndPlans(projectId);
    const { loadProjectTariff, isLoading: isLoadingProjectTariff, data: projectTariff, isError: isErrorProjectTariff } = useLoadProjectTariff(projectId);

    const handleOpenPage = (page: string) => {
        loadGroupsAndPlans();
        setRedirectPage(page);
    }

    useEffect(() => {
        if (!isLoadingSavedCards && savedCards && !isErrorSavedCards) {
            dispatch(navigateToPage("payment_settings"));
        } 
    }, [loadSavedCards, savedCards, isErrorSavedCards, isLoadingSavedCards]);

    useEffect(() => {
        if (!isLoadingStatistic && statistic && !isErrorStatistic) {
            dispatch(navigateToPage("dashboard"));
        } 
    }, [loadStatistic, statistic, isErrorStatistic, isLoadingStatistic]);

    useEffect(() => {
        if (!isLoadingGroupsAndPlans && groupsAndPlans && !isErrorGroupsAndPlans) {
            dispatch(navigateToPage(redirectPage));
        } 
    }, [loadGroupsAndPlans, groupsAndPlans, isErrorGroupsAndPlans, isLoadingGroupsAndPlans]);

    useEffect(() => {
        if (!isLoadingProjectTariff && projectTariff && !isErrorProjectTariff) {
            dispatch(navigateToPage("resources"));
        } 
    }, [loadProjectTariff, projectTariff, isErrorProjectTariff, isLoadingProjectTariff]);

    const hadleSelectProject = (project: string) => {
        dispatch(setProjectId(project));
    }

    /* 
    
    */

    return (
        <div className="main-page">
            <div className="main-page_container">
                <div className="main-page_wrapper">
                    {/* <span className="main-page_welcometext">
                        Панель управления Bot For Chat
                    </span> */}
                    { myProjects.length > 0 && (
                        <SelectPicker options={myProjects} onOptionSelect={hadleSelectProject}/>
                    )}
                    <ListButtons>
                        { myProjects.length > 0 && (
                            <>
                                <Button
                                    title="Dashboard"
                                    icon={dashboardIcon}
                                    action={loadStatistic}
                                    bgColor="#FF375F"
                                    isLoading={isLoadingStatistic}
                                />
                                <Button
                                    title="Статистика оплат"
                                    icon={paymentsIcon}
                                    action={() => handleOpenPage("statistic")}
                                    bgColor="#0A84FF"
                                    isLoading={isLoadingGroupsAndPlans && redirectPage == "statistic"}
                                />
                                 <Button
                                    title="Прогноз оплат"
                                    icon={statisticIcon}
                                    action={() => handleOpenPage("prognosis")}
                                    bgColor="#7A59A4"
                                    isLoading={false}
                                />
                                <Button
                                    title="Тарифы проекта"
                                    icon={officeBagDark}
                                    action={() => handleOpenPage("groups")}
                                    bgColor="#5E5CE6"
                                    isLoading={isLoadingGroupsAndPlans && redirectPage == "groups"}
                                />
                                 <Button
                                    title="Текущие подключения"
                                    icon={reportsIcon}
                                    action={loadProjectTariff}
                                    bgColor="#34C759"
                                    isLoading={isLoadingProjectTariff}
                                />
                                <Button
                                    title="Horizon Panel"
                                    icon={graphIcon}
                                    // action={() => (window.location.href = `${process.env.REACT_APP_API_URL}/horizon`)}
                                    action={() => openLink(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/redirect_with_token/${token}/horizon.index`, {
                                        tryInstantView: false,
                                    })}
                                    bgColor="#CE82FF"
                                    isLoading={false}
                                />
                                <Button
                                    title="Telescope Panel"
                                    icon={graphIcon}
                                    action={() => openLink(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/redirect_with_token/${token}/telescope`, {
                                        tryInstantView: false,
                                    })}
                                    bgColor="#CE82FF"
                                    isLoading={false}
                                />
                            </>
                        )}
{/*                         
                        <Button
                            title="База участников"
                            icon={membersIcon}
                            action={loadAvailablePlans}
                            bgColor="#0A84FF"
                            isLoading={isLoadingAvailablePlans}
                        /> */}
                        
                       
                        <Button
                            title="Настройки оплаты"
                            icon={creditCardDark}
                            action={loadSavedCards}
                            bgColor="#FF9F0A"
                            isLoading={isLoadingSavedCards}
                        />
                        <Button
                            title="Техническая поддержка"
                            icon={supportIconDark}
                            action={() => {
                                openTelegramLink("https://t.me/b4chat_support");
                            }}
                            bgColor="#8E8E93"
                        />
                    </ListButtons>
                    {/* <p className="main-page_dbg">ID: {initData.user.id}</p> */}
                </div>
            </div>
        </div>
    );
};

export default MainScreen;
